var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"base-required-mark"},[_vm._v(_vm._s(_vm.$t('parts.required')))])
}
var staticRenderFns = []

export { render, staticRenderFns }